import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Modal, Button, Row, Col, Radio, Input, InputNumber, message, TreeSelect, Select, Spin, Switch } from 'antd';
import ImgPreview from './ImgPreview';
import debounce from 'lodash/debounce';

const { SHOW_ALL } = TreeSelect;
const { TextArea } = Input;
const { Option } = Select;

@inject('ecodeDemoStore', 'ecodeGenreStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixClsNow: 'sys-ecode-detailConfig',
  }
  constructor(props) {
    super(props);
    this.state = {
      imgVisible: false
    }
  }
  componentWillUnmount() {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ detailConfigVisible: false, detailConfigParams: {} });
  }
  componentDidMount() {
    const { ecodeGenreStore: { getProperty } } = this.props;
    getProperty({name: ''});
  }
  onCancel = () => {
    const { ecodeDemoStore: { setMobxState, initDatas, activitykey, clearImg }, ecodeGenreStore:  { updateProperty, initGenreTree } } = this.props;
    initGenreTree();
    setMobxState({ detailConfigVisible: false, leader: undefined });
    clearImg();
    initDatas(activitykey, false);
  }
  onSubmit = () => {
    const { ecodeDemoStore: { setCaseType, setPrivatisation, setCharging, setViewUrl, activitykey, initDatas }, ecodeGenreStore:  {updateProperty, initGenreTree}} = this.props;
    let { ecodeDemoStore: { detail, detailConfigParams } } = this.props;
    detailConfigParams = toJS(detailConfigParams);
    detail = toJS(detail);
    updateProperty();
    initGenreTree();
    setCaseType(detailConfigParams.caseType, detail, true).then(() => {
      setPrivatisation(detailConfigParams.privatisation, detail).then(() => {
        setCharging(detailConfigParams.charging || 0, detail, true).then(() => {
          setViewUrl(detailConfigParams.previewUrl || 0, detail, true).then(() => {
            // message.success("保存成功");
            this.onCancel();
            initDatas(activitykey);
          });
        });
      });
    });
  }
  onChange = (value, label, extra) => {
    const { ecodeGenreStore: { updateProperty, setState } } = this.props;
    setState({genres: value});
    updateProperty();
  }
  onSearch = (e) => {
    const { ecodeGenreStore: {setState, getProperty}  } = this.props;
    setState({searchValue: e});
    getProperty();
  }
  setImg = () => {
    let { ecodeDemoStore: { getImageList, detailConfigParams } } = this.props;
    detailConfigParams = toJS(detailConfigParams);
    getImageList({demoId: detailConfigParams.id});
    this.setState({imgVisible: true});
  }
  imgCancel = () => {
    this.setState({imgVisible: false});
  }
  imgSubmit = () => {
    let { ecodeDemoStore: { setPreviewImg, detailConfigParams, imgChecked } } = this.props;
    detailConfigParams = toJS(detailConfigParams);
    setPreviewImg({demoId: detailConfigParams.id, id: imgChecked}).then(() => this.setState({imgVisible: false}));
  }
  handleSelectChange = (value) => {
    const { ecodeDemoStore: { setMobxState, setAppDirector, searchUsers } } = this.props;
    const key = value ? value.key : "";
    const _searchUsers = toJS(searchUsers);
    let params = {};
    for(let index in _searchUsers) {
      const user = _searchUsers[index];
      if(user.mobile === key) {
        params.mobile = `${key}_${user.mobileNum}`;
        break;
      }
    }
    setAppDirector(params);
    setMobxState({leader: value, searchUsers: []});
  }
  getConfigs = () => {
    const { ecodeDemoStore: { setMobxState, getUser, fetching } } = this.props;
    let { 
      ecodeDemoStore: { 
        detail,
        detailConfigParams,
        kbList,
        setCaseType,
        setPrivatisation,
        setViewPermission,
        setCharging,
        setViewUrl,
        setDemoKb,
        searchUsers,
        leader
      },
      ecodeGenreStore: {
        genreTreeList,
        searchValue,
        genres
      }
    } = this.props;
    detail = toJS(detail);
    detailConfigParams = toJS(detailConfigParams);
    genres = toJS(genres);
    kbList = toJS(kbList);
    leader = toJS(leader);
    const tProps = {
      treeData: genreTreeList,
      value: genres,
      onChange: this.onChange,
      onSearch: this.onSearch,
      treeCheckable: true,
      // showCheckedStrategy: SHOW_ALL,
      // showSearch: false,
      searchValue,
      searchPlaceholder: '请选择行业',
      style: {
        width: '100%',
      },
      dropdownStyle: {
        maxHeight: '500px',
      },
      // treeCheckStrictly: true,
      filterTreeNode: false,
      autoClearSearchValue: false,
      labelInValue: true,
    };
    const caseType = detailConfigParams.caseType ? detailConfigParams.caseType : 'case';
    return [
      {
        title: '案例类型',
        dataIndex: 'caseType',
        key: 'caseType',
        width: '10%',
        render: () => {
          return (
            <Radio.Group value={caseType} onChange={(e) => {
              setMobxState({ detailConfigParams: { ...detailConfigParams, 'caseType': e.target.value } });
              setCaseType(e.target.value, detail, true);
            }}>
              <Radio value='app'>付费</Radio>
              <Radio value='case'>免费</Radio>
            </Radio.Group>
          )
        }
      },
      caseType === "app" ? {
        title: '应用负责人',
        dataIndex: 'maintenance',
        key: 'maintenance',
        width: '10%',
        render: () => {
          return (
            <Select
              labelInValue
              showSearch
              allowClear
              value={leader}
              placeholder="选择负责人"
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              onSearch={debounce(getUser, 800)}
              onChange={this.handleSelectChange}
              style={{ width: '100%' }}
            >
              {toJS(searchUsers).map(d => (
                <Option key={d.mobile}>{d.username}</Option>
              ))}
            </Select>
          )
        }
      } : null,
      // {
      //   title: '私有化',
      //   dataIndex: 'privatisation',
      //   key: 'privatisation',
      //   width: '10%',
      //   render: () => {
      //     const val = detailConfigParams.privatisation ? detailConfigParams.privatisation : 'n';
      //     return (
      //       <Radio.Group value={val} onChange={(e) => {
      //         setMobxState({ detailConfigParams: { ...detailConfigParams, 'privatisation': e.target.value } });
      //         setPrivatisation(e.target.value, detail);
      //       }}>
      //         <Radio value='n'>共享</Radio>
      //         <Radio value='y'>私有</Radio>
      //       </Radio.Group>
      //     )
      //   }
      // },
      {
        title: '访问限制',
        dataIndex: 'viewPermission',
        key: 'viewPermission',
        width: '10%',
        render: () => {
          const val = detailConfigParams.viewPermission ? detailConfigParams.viewPermission : 'y';
          return (
            <Switch
              checked={val === "n"}
              onChange={(checked) => {
                const value = checked ? 'n' : 'y';
                setMobxState({ detailConfigParams: { ...detailConfigParams, 'viewPermission': value } });
                setViewPermission(value, detail);
              }}
            />
          )
        }
      },
      {
        title: '价格',
        dataIndex: 'charging',
        key: 'charging',
        width: '10%',
        render: () => {
          const val = detailConfigParams.charging ? detailConfigParams.charging : 0;
          return (
            <InputNumber
              value={val}
              min={0}
              onChange={(value) => {
                setMobxState({ detailConfigParams: { ...detailConfigParams, 'charging': value } });
              }}
              onBlur={() => {
                setCharging(val, detail, true);
              }}
              formatter={value => `¥ ${value}`}
            />
          )
        }
      },
      {
        title: '行业/职能',
        dataIndex: 'genre',
        key: 'genre',
        width: '10%',
        render: () => {
          return (
            <TreeSelect {...tProps} />
          )
        }
      },
      {
        title: '最低兼容kb',
        dataIndex: 'kb',
        key: 'kb',
        width: '10%',
        render: () => {
          const val = detailConfigParams.kbVersion ? detailConfigParams.kbVersion : undefined;
          return (
            <Select
              value={val}
              placeholder="请选择最低兼容kb"
              onChange={value => {
                setDemoKb({id: detail.id, kbVersion: value});
                setMobxState({ detailConfigParams: { ...detailConfigParams, 'kbVersion': value } });
              }}
              showSearch
              style={{width: '100%'}}
            >
              {
                Array.isArray(kbList) && kbList.length > 0 && kbList.map(item => (
                  <Option value={item} key={item}>{item}</Option>
                ))
              }
            </Select>
          )
        }
      },
      {
        title: '预览地址',
        dataIndex: 'previewUrl',
        key: 'previewUrl',
        width: '10%',
        render: () => {
          const val = detailConfigParams.previewUrl ? detailConfigParams.previewUrl : '';
          return (
            <TextArea
              value={val}
              rows={4}
              autoSize={{ minRows: 4, maxRows: 4 }}
              onChange={(e) => {
                setMobxState({ detailConfigParams: { ...detailConfigParams, 'previewUrl': e.target.value } });
              }}
              onBlur={(e) => {
                setViewUrl(e.target.value || 0, detail, true);
              }}
            // formatter={value => `¥ ${value}`}
            />
          )
        }
      },
      {
        title: '预览图片',
        dataIndex: 'previewImg',
        key: 'previewImg',
        width: '10%',
        render: () => {
          return (
            <Button onClick={() => this.setImg()} type="primary">设置预览图片</Button>
          )
        }
      },
    ]
  }
  render() {
    const { prefixClsNow, ecodeDemoStore: { detailConfigVisible, previewImgList, imgChecked, setMobxState, imgLoading, setPreviewImgLoading } } = this.props;
    const { imgVisible } = this.state;
    const configs = this.getConfigs();
    return (
      <Modal
        title="详细设置"
        visible={detailConfigVisible}
        onCancel={this.onCancel}
        footer={
          [
            // (<Button onClick={this.onSubmit} key="detailSubmit" type="primary">确定</Button>),
            (<Button onClick={this.onCancel} key="detailCancel">返回</Button>),
          ]
        }
      >
        {
          configs.map((config) => {
            return config ? (
              <Row key={config.key} className={`${prefixClsNow}-form`}>
                <Col span={8} className={`${prefixClsNow}-label`}>{config.title}：</Col>
                <Col span={16} className={`${prefixClsNow}-wrapper`}>{config.render()}</Col>
              </Row>
            ) : null
          })
        }
        <ImgPreview
          visible={imgVisible}
          onCancel={this.imgCancel}
          onOk={this.imgSubmit}
          imgList={previewImgList}
          value={imgChecked}
          onChange={value => setMobxState({imgChecked: value})}
          imgLoading={imgLoading}
          confirmLoading={setPreviewImgLoading}
        />
      </Modal>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/DetailConfig.js